import { render, staticRenderFns } from "./TopPurchases.vue?vue&type=template&id=3e367ea2&scoped=true"
import script from "./TopPurchases.vue?vue&type=script&lang=js"
export * from "./TopPurchases.vue?vue&type=script&lang=js"
import style0 from "./TopPurchases.vue?vue&type=style&index=0&id=3e367ea2&prod&lang=css"
import style1 from "./TopPurchases.vue?vue&type=style&index=1&id=3e367ea2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e367ea2",
  null
  
)

export default component.exports